import { PaletteOptions } from "@mui/material/styles/createPalette"

// import {purple} from "~/theme/palette/colors/colors";

export const lightColors: PaletteOptions = {
  primary: {
    main: "#0055B2",
    11: "#001A37",
    10: "#002650",
    9: "#003A79",
    8: "#004796",
    7: "#0055B2",
    6: "#2970BE",
    5: "#528BCB",
    4: "#A3C9F3",
    3: "#D1E4FA",
    2: "#EEF5FC",
    1: "#F5FAFF",
  },
  secondary: {
    main: "#FF8C00",
    10: "#422400",
    9: "#834800",
    8: "#AD5F00",
    7: "#D67600",
    6: "#FF8C00",
    5: "#FF9E29",
    4: "#E39F4D",
    3: "#F2B973",
    2: "#FCD5A5",
    1: "#FFEFDB",
  },
  divider: "#EDF2FF",
  background: {
    main: "#FAFAFA",
    default: "#FFFFFF",
    paper: "#FFFFFF",
    1: "#FFFFFF",
    2: "#FDFDFD",
    3: "#FAFAFA",
    4: "#F7F7F7",
    5: "#F3F3F3",
    6: "#F1F1F1",
  },

  shadow: {
    1: "#00000014",
    2: "#0000001C",
    3: "#0000002B",
    4: "#00000033",
    5: "#00000047",
  },

  success: {
    main: "#77FE7A",
    5: "#118715",
    4: "#20CF27",
    3: "#77FE7A",
    2: "#BBFEBE",
    1: "#E4FFE5",
  },

  warning: {
    main: "#F7DF00",
    5: "#998A00",
    4: "#E1CB00",
    3: "#F7DF00",
    2: "#FFEF9D",
    1: "#FFF8DB",
  },

  error: {
    main: "#B5260B",
    5: "#920300",
    4: "#B5260B",
    3: "#EF4D2F",
    2: "#FEE2E1",
    1: "#FFEFEF",
  },

  info: {
    main: "#51C0FF",
    5: "#00527C",
    4: "#007CB4",
    3: "#51C0FF",
    2: "#CCE6FD",
    1: "#EDF7FF",
  },

  grey: {
    main: "#8A8A8A",
    16: "#1A1A1A",
    15: "#303030",
    14: "#4A4A4A",
    13: "#616161",
    12: "#8A8A8A",
    11: "#B5B5B5",
    10: "#CCC",
    9: "#D4D4D4",
    8: "#E3E3E3",
    7: "#EBEBEB",
    6: "#F1F1F1",
    5: "#F3F3F3",
    4: "#F7F7F7",
    3: "#FAFAFA",
    2: "#FDFDFD",
    1: "#FFF",
  },

  text: {
    primary: "#4A4A4A",
    secondary: "#FFFFFF",
    16: "#1A1A1A",
    15: "#303030",
    14: "#4A4A4A",
    13: "#616161",
    12: "#8A8A8A",
    11: "#B5B5B5",
    10: "#CCCCCC",
    9: "#D4D4D4",
    8: "#E3E3E3",
    7: "#EBEBEB",
    6: "#F1F1F1",
    5: "#F3F3F3",
    4: "#F7F7F7",
    3: "#FAFAFA",
    2: "#FDFDFD",
    1: "#FFFFFF",
    disabled: "",
  },

  //Ignore inherit & default
  //These two object were added just to handle color change in some Mui components
  inherit: {
    main: "inherit",
    10: "inherit",
    9: "inherit",
    8: "inherit",
    7: "inherit",
    6: "inherit",
    5: "inherit",
    4: "inherit",
    3: "inherit",
    2: "inherit",
    1: "inherit",
  },
  default: {
    main: "#727CF4",
    10: "#212EBB",
    9: "#3440C1",
    8: "#4D59D7",
    7: "#646FED",
    6: "#727CF4",
    5: "#7984FF",
    4: "#6B91FB",
    3: "#7B9EFE",
    2: "#98B3FE",
    1: "#cddbff",
  },

  // purple: {
  //   main: purple.main,
  //   16: purple["16"],
  //   15: purple["15"],
  //   14: purple["14"],
  //   13: purple["13"],
  //   12: purple["12"],
  //   11: purple["11"],
  //   10: purple["10"],
  //   9: purple["9"],
  //   8: purple["8"],
  //   7: purple["7"],
  //   6: purple["6"],
  //   5: purple["5"],
  //   4: purple["4"],
  //   3: purple["3"],
  //   2: purple["2"],
  //   1: purple["1"],
  // },
}
